import React from 'react'
import { Card, Text, Box, Flex, ActionIcon, Grid, Group } from '@mantine/core'
import { currencyFormat } from 'simple-currency-format'
import { PiArrowUpRightBold, PiArrowDownRightBold } from 'react-icons/pi'

export const StatsCard = ({ title, value, icon, color = 'yellow', description, currency = false, mono = true, diff }) => {
  const displayValue = currency && typeof value === 'number'
    ? currencyFormat(value, 'es-MX', 'MXN', 2)
    : value;

  const isPositive = diff > 0;
  const isNegative = diff < 0;

  return (
    <Card withBorder radius="lg" p="lg" shadow="sm" style={{ height: '100%' }}>
      <Flex justify="space-between" align="start">
        <Box>
          <Text size="xs" fw={800} c="dimmed" tt="uppercase" className="tracking-widest">{title}</Text>
          <Text 
            size="24px" 
            fw={800} 
            mt={4}
            c={`${color}.7`}
            style={{ 
              fontFamily: mono ? 'var(--mantine-font-family-monospace)' : 'inherit',
              letterSpacing: '-1px'
            }}
          >
            {displayValue !== null ? displayValue : '---'}
          </Text>
          
          {diff !== undefined && diff !== 0 && (
            <Group gap={4} mt={4}>
              <Text 
                size="xs" 
                fw={700} 
                c={isPositive ? 'green.6' : isNegative ? 'red.6' : 'dimmed'}
                className="flex items-center gap-1"
              >
                {isPositive ? <PiArrowUpRightBold size={12} /> : isNegative ? <PiArrowDownRightBold size={12} /> : null}
                {Math.abs(diff)}%
              </Text>
              <Text size="xs" c="dimmed" fw={500}>vs mes anterior</Text>
            </Group>
          )}
        </Box>
        <ActionIcon variant="light" color={color} size="xl">
          {icon}
        </ActionIcon>
      </Flex>
      {description && <Text size="xs" c="dimmed" fw={500} mt="sm">{description}</Text>}
    </Card>
  );
};

export const StatsGrid = ({ data }) => (
  <Grid px="md" mb="xl">
    {data.map((stat, index) => (
      <Grid.Col key={index} span={{ base: 12, md: 4 }}>
        <StatsCard {...stat} />
      </Grid.Col>
    ))}
  </Grid>
);
